App.module('Entities', function(Entities, App, Backbone, Marionette, $){
    'use strict';

    Entities.PagerEntity = Backbone.PageableCollection.extend({
        url:'/vitality/search_result/suggest/?',
        //&from=0&size=10
        state: {
            pageSize: 10
        },
        queryParams: {
            currentPage: null,
            page: null,
            from: function(){
                return this.state.currentPage*this.state.pageSize - this.state.pageSize;
            },
            pageSize: null,
            size: function() { return this.state.pageSize; },
            totalPages: null,
            totalRecords: null,
            sortKey: null,
            order: null,
            fuzzy: 0,
            isEs : function(){
                var reg = /(https?:\/\/(www)?)(.*)/;
                var match=reg.exec(window.location);
                if(match && match[3]){
                    return match[3].split('.')[0]==='es';
                }
                return false;
            }
        },
        parseState: function (resp) {
            return {totalRecords: resp.hits.total};
        },
        parseRecords: function (resp) {
            if(resp.hits && resp.hits.hits) {
                $.each(resp.hits.hits, function (i, el) {
                    el._source.url = HW.adaptLink(el._source.url);
                });
            }

            return resp.hits.hits;
        }
    });
});